import { APP_INITIALIZER, NgModule, Provider } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { TranslateModule } from '@ngx-translate/core';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MessageService } from 'primeng/api';
import { PanelMenuModule } from 'primeng/panelmenu';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { StepsModule } from 'primeng/steps';
import { DividerModule } from 'primeng/divider';

import { ConfigService } from '@core/services';
import { HttpInterceptor } from '@core/interceptors/http.interceptor';
import {
    AppTopBarComponent,
    AppMenuComponent,
    AppMenuitemComponent,
    AppFooterComponent,
    AppMainComponent,
    AppRightMenuComponent,
    TimeZoneContainerComponent,
    StepComponentComponent,
} from '@core/components';
import { SubMenuPositionDirective } from '@core/directives';

export function initConfig(config: ConfigService): object {
    return () => config.load();
}

const INTERCEPTOR_PROVIDER: Provider = {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpInterceptor,
    multi: true
};

@NgModule({
    declarations: [
        AppTopBarComponent,
        AppMenuComponent,
        AppMenuitemComponent,
        AppFooterComponent,
        AppMainComponent,
        AppRightMenuComponent,
        SubMenuPositionDirective,
        TimeZoneContainerComponent,
        StepComponentComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        TranslateModule,
        RadioButtonModule,
        DropdownModule,
        BreadcrumbModule,
        ButtonModule,
        RippleModule,
        InputTextModule,
        ReactiveFormsModule,
        InputSwitchModule,
        PanelMenuModule,
        MultiSelectModule,
        OverlayPanelModule,
        StepsModule,
        DividerModule,
    ],
    exports: [
        AppTopBarComponent,
        AppMenuComponent,
        AppMenuitemComponent,
        AppFooterComponent,
        AppMainComponent,
        AppRightMenuComponent,
        TimeZoneContainerComponent,
        RouterModule,
        FormsModule,
        TranslateModule,
        RadioButtonModule,
        DropdownModule,
        BreadcrumbModule,
        ButtonModule,
        RippleModule,
        InputTextModule,
        ReactiveFormsModule,
        InputSwitchModule,
        PanelMenuModule,
        MultiSelectModule,
        OverlayPanelModule,
        StepComponentComponent,
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initConfig,
            deps: [ConfigService],
            multi: true,
        },
        MessageService,
        INTERCEPTOR_PROVIDER,
        TitleCasePipe,

    ]
})
export class CoreModule {
}
